// PremiumToggle — Marks the published analysis as PRO-only content.
import React from "react";
import { Crown } from "lucide-react";
import { tFases } from "../../../i18n/shadow-fases";

export const PremiumToggle = ({ isPro, lang, premiumOn, setPremiumOn, onProGate }) => (
  <label className="mt-3 flex cursor-pointer items-center justify-between gap-2 rounded-2xl border border-amber-400/20 bg-amber-400/[0.03] p-3">
    <div className="flex items-center gap-2">
      <span className="text-[10px] font-black uppercase tracking-[0.22em] text-amber-200">
        🔒 {tFases(lang, "publish_premium_label")}
      </span>
      {!isPro && (
        <span className="inline-flex items-center gap-1 rounded-full border border-amber-400/40 bg-amber-400/10 px-2 py-0.5 text-[9px] font-bold uppercase tracking-[0.15em] text-amber-200">
          <Crown className="h-2.5 w-2.5" /> {tFases(lang, "publish_poll_pro")}
        </span>
      )}
      <span className="text-[10px] text-white/40">{tFases(lang, "publish_premium_sub")}</span>
    </div>
    <input
      type="checkbox"
      checked={premiumOn}
      disabled={!isPro}
      onChange={(e) => {
        if (!isPro) { onProGate("chars"); return; }
        setPremiumOn(e.target.checked);
      }}
      data-testid="shadow-publish-premium-toggle"
      className="h-4 w-4 cursor-pointer accent-amber-500 disabled:cursor-not-allowed"
    />
  </label>
);

export default PremiumToggle;
